import Image from "../Image/Image";
function ImageTextLayout({ link, imageSource, text }) {
  return (
    <>
      <div className="col-4 book-recommendation-edit-margin">
        <a href={link} target="_blank" className="document-container-link">
          <Image
            width={100}
            height={150}
            source={imageSource}
            alternativetext="Book cover caption"
          />
        </a>
      </div>
      <div className="col-8 book-recommendation-edit-margin">
        <p
          className="text-light book-recommendation-summary-overflow"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={text}
        >
          {text}
        </p>
      </div>
    </>
  );
}

export default ImageTextLayout;
